'use client';

import { Download } from '@doist/icons/brand';
import { Box, Button, Container } from '@doist/marketist';
import cn from 'clsx';
import { GetStartedButtonSimple } from 'components/Get-Started-Button/Get-Started-Button';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useTranslation } from 'next-i18next';
import { ExploreItAll } from './explore-it-all';
import css from './feature-teams.module.css';
export function Prefooter() {
  const {
    t
  } = useTranslation('features-teams');
  return <Box className={css.prefooterBackground} data-sentry-element="Box" data-sentry-component="Prefooter" data-sentry-source-file="prefooter.tsx">
            <Box className="mbs-128 lg-mbs-192" data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                <ExploreItAll data-sentry-element="ExploreItAll" data-sentry-source-file="prefooter.tsx" />
            </Box>
            <Container width="base" className={cn(css.prefooter, 'pbs-48 md-pbs-64')} data-sentry-element="Container" data-sentry-source-file="prefooter.tsx">
                <SectionHeader level="2" size="lg" title={t('experienceItYourself')} data-sentry-element="SectionHeader" data-sentry-source-file="prefooter.tsx" />
                <Box className={css.buttons} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                    <GetStartedButtonSimple size="xl" data-sentry-element="GetStartedButtonSimple" data-sentry-source-file="prefooter.tsx" />
                    <Button startIcon={Download} variant={'quinary'} href="/downloads" size="xsmall" data-sentry-element="Button" data-sentry-source-file="prefooter.tsx">
                        {t('downloadApps')}
                    </Button>
                </Box>
            </Container>
        </Box>;
}